import { cn } from "@newxsystems/shared";
import { WohaAction } from "../WohaAction/WohaAction";
import { WohaMedia } from "../WohaMedia/WohaMedia";
import { WohaRichText } from "../WohaRichText/WohaRichText";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

export const HeroBackgroundImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroBackgroundImageProps) => {
  const centered = alignment === "center";

  return (
    <div className="relative flex min-h-[42rem] overflow-hidden bg-charcoal md:min-h-[46rem] min-[96rem]:rounded-2xl">
      <WohaMedia
        className="absolute inset-0 h-full rounded-none"
        imageClassName="object-cover"
        media={image.image}
        priority
        sizes="(min-width: 1536px) 1536px, 100vw"
      />

      <div className="container relative z-10 flex min-h-[42rem] items-end py-5 md:min-h-[46rem] md:py-10">
        <div
          className={cn(
            "w-full max-w-[43rem] rounded-xl border border-white/10 bg-charcoal/95 p-6 text-white backdrop-blur-sm md:p-10 lg:p-12",
            centered && "mx-auto text-center",
          )}
        >
          <div className={cn("flex flex-col gap-4", centered && "items-center")}>
            {eyebrow ? (
              <p className="text-sm font-medium tracking-wide text-white/75">{eyebrow}</p>
            ) : null}
            {heading ? (
              <h1 className="font-satoshi text-4xl font-medium leading-[1.02] text-balance sm:text-5xl md:text-6xl">
                {heading}
              </h1>
            ) : null}
            {description ? (
              <WohaRichText
                className="max-w-[60ch] text-base leading-7 text-white/75"
                content={description}
              />
            ) : null}
            {buttons?.length ? (
              <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
                {buttons.map((button, index) => (
                  <WohaAction
                    action={button}
                    className={
                      button.style === "primary" || !button.style
                        ? "border-white bg-white text-charcoal hover:bg-paper-mist"
                        : undefined
                    }
                    key={`${button.href}-${index}`}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
HeroBackgroundImage.displayName = "Content::HeroBackgroundImage";
